import React from "react";
import { formatRut, LABEL_INPUT_FONT_SIZE, validateRut } from "../../ConstsAndUtils/utils";
import SharedTitle from "./SharedTitle";
import { Box, Button, Collapse, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, Select, Switch, Typography } from "@material-ui/core";
import { CheckBox, Save, Warning } from "@material-ui/icons";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CapacidadInstaladaPropuesta from "./CapacidadInstaladaPropuesta";
import AsInstalacionFuncionamiento from "../FormCapacidadInstaladaComponents/AsInstalacionFuncionamiento";
import AppTextInput from "@jumbo/components/Common/formElements/AppTextInput";

const CapacidadInstaladaContentBody = ({
    titulo,
    descripcion,
    hasService,
    setHasService,
    guardar_flag,
    flag_cambios_guardados,
    deleteServicio,
    setOpen,
    open,
    nro_resolucion,
    fecha_resolucion,
    aut_sanitaria,
    set_nro_resolucion,
    set_fecha_resolucion,
    set_aut_sanitaria,
    tipo_servicio,
    set_tipo_servicio,
    nombre_proveedor,
    set_nombre_proveedor,
    rut_proveedor,
    set_rut_proveedor,
    flag_mostrar,
    enviarDataAutsanitaria,
    instalacionesList = [],
    hasCount,
    campos,
    setIsLoading,
    tiposAux,

}) => {

    return (

        <div style={{ width: '100%', flexBasis: '100%', backgroundColor: 'white' }}>

            <SharedTitle
                title={titulo}
            />
            <Grid item xs={12} sm={12} md={12} style={{ paddingTop: 15, paddingBottom: 15, paddingLeft: 25, paddingRight: 25 }}>
                <p>{descripcion}</p>
            </Grid>

            <Grid
                container
                item
                xs={12}
            >

                <Grid
                    direction='row'
                    container
                    item
                    xs={12}
                    spacing={4}
                    style={{
                        backgroundColor: 'white',
                        paddingTop: 5,
                        borderRadius: 5,
                        paddingBottom: 5,
                        marginTop: 15,
                        margin: 0
                    }}
                >

                    <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        alignItems="center"
                        spacing={2}
                        style={{ paddingLeft: 20, paddingRight: 20 }}
                    >
                        <FormControl>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={hasService === 1}
                                        color="primary"
                                        onChange={(e) => {
                                            const v = e.target.checked ? 1 : 0;
                                            setHasService(v);

                                            if (v === 0 && !guardar_flag) {
                                                deleteServicio();
                                            }
                                        }}
                                    />
                                }
                                label={
                                    <Typography style={{ fontSize: 14 }}>
                                        {"¿Prestador otorga prestaciones de " + titulo + "?"}
                                    </Typography>
                                }
                                labelPlacement="start"
                            />
                        </FormControl>

                        {hasService === 1 && (
                            <>
                                <Typography style={{ fontSize: 14, color: "grey", marginLeft: 10 }}>
                                    <Warning style={{ fontSize: 12 }} />
                                    Debe contar con autorización sanitaria vigente
                                </Typography>
                                <Box flexGrow={1} />
                                {
                                    flag_cambios_guardados ?
                                        <Typography style={{ fontSize: 14, color: "grey" }}>
                                            <CheckBox style={{ fontSize: 12 }} /> Cambios guardados
                                        </Typography>
                                        :
                                        null
                                }

                            </>
                        )}
                    </Grid>



                    <Grid item xs={12} container justifyContent="flex-end" alignItems="center">

                        {hasService === 1 ? (
                            <Grid container direction='row' justifyContent='space-between' style={{ paddingLeft: 20, paddingRight: 20 }}>
                                <FormControl component={"fieldset"}
                                    style={{
                                        border: "1px solid rgba(0, 0, 0, 0.23)",
                                        borderRadius: 4,
                                        padding: "16px",
                                        width: "100%"
                                    }}
                                >
                                    <FormLabel component={"legend"}>
                                        <Typography style={{ fontSize: 14, color: 'black' }}>

                                            Autorización sanitaria
                                        </Typography>

                                    </FormLabel>
                                    <Grid container direction='row' justifyContent='flex-end'
                                        style={{ marginTop: -25 }}
                                    >

                                        <ExpandMoreIcon
                                            onClick={() => setOpen(v => !v)}
                                            style={{
                                                transition: 'transform 150ms ease',
                                                transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                                                cursor: 'pointer'
                                            }}
                                        />

                                    </Grid>
                                    <Collapse in={hasService === 1 && open} timeout="auto" unmountOnExit style={{ width: '100%' }}>
                                        {
                                            hasService === 1 ?
                                                <div >
                                                    <AsInstalacionFuncionamiento
                                                        title={"Autorización sanitaria"}
                                                        nResolucion={nro_resolucion}
                                                        fechaOtorgada={fecha_resolucion}
                                                        autoridadQueDicta={aut_sanitaria}
                                                        setNResolucion={set_nro_resolucion}
                                                        setFechaOtorgada={set_fecha_resolucion}
                                                        setAutoridadQueDicta={set_aut_sanitaria}
                                                    >


                                                        {
                                                            hasService === 1 ?
                                                                <Grid item xs={4} sm={4}>
                                                                    <FormControl size='small' fullWidth>
                                                                        <InputLabel
                                                                            inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                                                            htmlFor="grouped-native-select"
                                                                            style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                                                            {"Tipo de servicio"}
                                                                        </InputLabel>
                                                                        <Select
                                                                            inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                                                            native
                                                                            label={"Tipo de servicio"}
                                                                            id="grouped-native-select"
                                                                            fullWidth
                                                                            variant='outlined'
                                                                            value={tipo_servicio}
                                                                            onChange={(e) => {
                                                                                set_tipo_servicio(parseInt(e.target.value))
                                                                            }}
                                                                        >
                                                                            {tiposAux.map((item, index) => {
                                                                                return <option key={index} value={item.value}> {item.label}</option>
                                                                            })}
                                                                        </Select>
                                                                    </FormControl>

                                                                </Grid>
                                                                :
                                                                null
                                                        }

                                                        {
                                                            tipo_servicio === 2 && hasService ?
                                                                <Grid item xs={4} sm={4}>
                                                                    <AppTextInput
                                                                        InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                                                        fullWidth
                                                                        size={'small'}
                                                                        variant="outlined"
                                                                        label="Nombre Proveedor"
                                                                        value={nombre_proveedor}
                                                                        onChange={e => {
                                                                            set_nombre_proveedor(e.target.value)
                                                                        }}
                                                                    />

                                                                </Grid>

                                                                :

                                                                null

                                                        }

                                                        {
                                                            tipo_servicio === 2 && hasService ?
                                                                <Grid item xs={4} sm={4}>
                                                                    <AppTextInput
                                                                        InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                                                        fullWidth
                                                                        size={'small'}
                                                                        variant="outlined"
                                                                        label="RUT Proveedor"
                                                                        value={rut_proveedor}
                                                                        error={!validateRut(rut_proveedor)}
                                                                        onChange={e => {
                                                                            let inputRut = e.target.value;
                                                                            inputRut = inputRut.slice(0, 13);
                                                                            const formattedRut = formatRut(inputRut);
                                                                            set_rut_proveedor(formattedRut)
                                                                        }}
                                                                    />

                                                                </Grid>

                                                                :

                                                                null

                                                        }

                                                    </AsInstalacionFuncionamiento>

                                                </div>
                                                :

                                                null
                                        }
                                        <Grid
                                            container
                                            item
                                            xs={12}
                                            spacing={4}
                                            justifyContent='flex-end'
                                            style={{
                                                backgroundColor: 'white',
                                                paddingTop: 5,
                                                borderRadius: 5,
                                                paddingBottom: 5,
                                                marginTop: 15,
                                                marginBottom: 15
                                            }}>

                                            {
                                                !(hasService === 1 && flag_mostrar) ?
                                                    <Grid item xs={3} sm={3} container direction='column' justifyContent='center'>
                                                        <Button
                                                            variant='outlined'
                                                            color='primary'
                                                            disabled={guardar_flag}
                                                            onClick={() => {
                                                                enviarDataAutsanitaria()
                                                            }}

                                                        >
                                                            <Save style={{ marginRight: 10 }} />
                                                            Guardar y continuar
                                                        </Button>
                                                    </Grid>
                                                    : null

                                            }
                                        </Grid>


                                    </Collapse>
                                </FormControl>

                            </Grid>

                        ) : null}
                    </Grid>
                </Grid>


            </Grid>

            {(instalacionesList.length > 0 && hasService === 1 && flag_mostrar

            ) ?

                <Grid container direction='row' justifyContent='space-between' style={{ paddingLeft: 25, paddingRight: 25 }}>
                    <FormControl component={"fieldset"}
                        style={{
                            border: "1px solid rgba(0, 0, 0, 0.23)",
                            borderRadius: 4,
                            padding: "16px",
                            width: "100%"
                        }}
                    >
                        <FormLabel component={"legend"}>
                            <Typography style={{ fontSize: 14, color: 'black' }}>

                                {"Servicios de " + titulo}
                            </Typography>

                        </FormLabel>
                        <CapacidadInstaladaPropuesta
                            espacios={instalacionesList}
                            hasCount={hasCount}
                            fields={campos}
                            setLoading={setIsLoading}
                            datosAut={{
                                "aut_sanitaria": aut_sanitaria,
                                "nro_resolucion": nro_resolucion,
                                "fecha_resolucion": fecha_resolucion
                            }}
                        />
                    </FormControl>
                </Grid>
                :
                null
            }
        </div>
    )


}

export default CapacidadInstaladaContentBody